namespace Areas.TimeEntry.Correction {
    "user strict";
        
    let employeeId: number = 0;
    let weekEndingDateProgrammaticallySet: boolean = false;
    
    export function viewLink(cellElement, cellInfo) {
        const employeeId = String(cellInfo.data.employeeId);
        const startDate = String(cellInfo.data.weekEndingDateCalc);
        const linkInfo = `<a href= '/Employee/Time/Index/${employeeId}?start=${startDate}' target=_blank >View</a>`;
        cellElement.html(linkInfo);
    }

    export function showEmployeeDialog() {
        const employeeDialog = new Areas.Dialogs.Employee.EmployeeDialog(employeeDialogClosing);
    }

    export function showAccountDialog() {
        const accountDialog = new Areas.Dialogs.Account.AccountDialog(accountDialogClosing);
    }

    export function showJobsDialog() {
        const jobsDialog = new Areas.Dialogs.Jobs.JobsDialog(jobsDialogClosing);
    }

    export function setWeekEndingDateFilterValue(e: any) {
        const form = e.component;
        form.option("formData", { weekEndingDate: Areas.getNextSaturdayDate() });
    }

    function accountDialogClosing(dialogResult: DialogResult, data: any) {
        if (dialogResult === DialogResult.Cancel) {
            return;
        } 

        const form = $("#CorrectionGridFilterForm").dxForm("instance");
        const formData = form.option("formData");

        formData.accountId = data.accountId;
        formData.accountName = data.projectName; 

        form.option("formData", formData);
    }

    function jobsDialogClosing(dialogResult: DialogResult, data: any) {
        if (dialogResult === DialogResult.Cancel) {
            return;
        } 

        const form = $("#CorrectionGridFilterForm").dxForm("instance");
        const formData = form.option("formData");

        formData.accountWorkOrderId = data.accountWorkOrderId;
        formData.jobName = data.displayName; 

        form.option("formData", formData);
 
    }

    export function clearSelections() {
        const form = $("#CorrectionGridFilterForm").dxForm("instance");
        const formData = form.option("formData");

        formData.employeeId = 0;
        formData.accountId = 0;
        formData.accountWorkOrderId = 0;
        formData.employeeName = "";
        formData.accountName = "";
        formData.jobName = "";

        form.option("formData", formData);
    }

    function employeeDialogClosing(dialogResult: DialogResult, data: any) {
        if (dialogResult === DialogResult.Cancel) {
            return;
        } 

        const form = $("#CorrectionGridFilterForm").dxForm("instance");
        const formData = form.option("formData");

        formData.employeeId = data.employeeId;
        formData.employeeName = data.displayName;

        form.option("formData", formData);
    }

    export function showCorrectionDialog() {
        if (allSelectedAreValid()) {
            var timeEntries = getSelectedTimeEntries();

            const params = { employeeId: employeeId, timeEntries: timeEntries };
            const correctionDialog = new Areas.Dialogs.TimeEntryCorrection.TimeEntryCorrectionDialog(
                correctionDialogClosing,
                params);
        }
    }

    function allSelectedAreValid() {
        const correctionGrid = $("#CorrectionGrid").dxDataGrid("instance");
        const selectedRows = correctionGrid.getSelectedRowsData();
        //check for cancelled or not extracted
        for (var record in selectedRows) {
            employeeId = selectedRows[record].employeeId;
            if (selectedRows[record].isCancelled === true || selectedRows[record].glEntryCreatedDateTime === null) {
                DevExpress.ui.notify("Selected Records must be Extracted and not Cancelled", "warning", 2000);
                return false;

            }
        }
        return true;
    }
    export function showReversalDialog() {
        if (allSelectedAreValid()) {
            var timeEntries = getSelectedTimeEntries();


            const params = { employeeId: employeeId, timeEntries: timeEntries };
            const reversalDialog = new Areas.Dialogs.TimeEntryReversal.TimeEntryReversalDialog(reversalDialogClosing,
                params);
        }
    }

    function reversalDialogClosing(dialogResult: DialogResult, data: any) {
        if (dialogResult === DialogResult.Cancel) {
            return;
        } 

        const correctionGrid = $("#CorrectionGrid").dxDataGrid("instance");        
        correctionGrid.deselectAll();
        
        Areas.refreshGrid("CorrectionGrid");
    }


    function getSelectedTimeEntries() {
        const correctionGrid = $("#CorrectionGrid").dxDataGrid("instance");
        const selectedRows = correctionGrid.getSelectedRowsData();
     
        return $.map(correctionGrid.getSelectedRowsData(), function (item:any) { return item.timeEntryId });
    }

    function correctionDialogClosing(dialogResult: DialogResult, data: any) {
        if (dialogResult === DialogResult.Cancel) {
            return;
        } 

        const correctionGrid = $("#CorrectionGrid").dxDataGrid("instance");        
        correctionGrid.deselectAll();
        
        Areas.refreshGrid("CorrectionGrid");
    }

    export function canExecuteQuery() {
        const filterForm = $("#CorrectionGridFilterForm").dxForm("instance");
        const data = filterForm.option("formData");

        const useWeekEndingDate = data.useWeekEndingDate;
        const weekEndingDate = data.weekEndingDate;
        const timePeriod = data.timePeriod;  
        const startDate = data.startDate;
        const endDate = data.endDate;
        
        const validWeekend = useWeekEndingDate === true && Areas.isNotEmpty(weekEndingDate);
        const validTimePeriod = validTimePeriodSelected(timePeriod, startDate, endDate); 
        return validWeekend || validTimePeriod;
    }
    
    function validTimePeriodSelected(timePeriod, startDate, endDate) {
        if (Areas.isNotEmpty(timePeriod)) {
            if (timePeriod === "All") {
                return true;
            }
        }

        return Areas.isNotEmpty(startDate) && Areas.isNotEmpty(endDate);
    }

    export function getEmployeeId() {
        return getFormData().employeeId;
    }

    export function getAccountId() {
        return getFormData().accountId;
    }

    export function getAccountWorkOrderId() {
        return getFormData().accountWorkOrderId;
    }

    export function getWeekEndingDate() {
        return moment(getFormData().weekEndingDate).format("YYYY-MM-DD");
    }

    export function getUseWeekEndingDate() {
        return getFormData().useWeekEndingDate;
    }

    export function getExcludeUploaded() {
        return getFormData().excludeUploaded;
    }

    export function getExcludeReversals() {
        return getFormData().excludeReversals;
    }

    export function getTimePeriod() {
        return getFormData().timePeriod;
    }

    export function getStartDate() {
        return moment(getFormData().startDate).format("YYYY-MM-DD");
    }

    export function getEndDate() {
        return moment(getFormData().endDate).format("YYYY-MM-DD");
    }

    export function loadTimeEntries() {
        Areas.refreshGrid("CorrectionGrid");
    }

    export function weekEndingDateChanged(e: any) {
        if (weekEndingDateProgrammaticallySet === true) {
            weekEndingDateProgrammaticallySet = false;
            return;
        }

        if (weekEndingDateProgrammaticallySet === false) {
            const form = $("#CorrectionGridFilterForm").dxForm("instance");
            const data = form.option("formData");

            data.weekEndingDate = Areas.getNextSaturdayFromDate(e.value);

            form.option("formData", data);
            weekEndingDateProgrammaticallySet = true;
            return;
        }
    }

    export function timePeriodChanged(e: any) {
        if (e.value === null) return;

        $.get(`/TimeEntry/Correction/GetTimePeriod/?timePeriod=${e.value}`, (data) => {
            const form = $("#CorrectionGridFilterForm").dxForm("instance");
            const formData = form.option("formData");

            formData.startDate = data.startDate;
            formData.endDate = data.endDate;
            form.option("formData", formData);
        })
    }


    export function onTimeEntryGridContentReady(e: any) {
        const selectAllCheckBox = e.element.find(".dx-header-row").find(".dx-select-checkbox");
        selectAllCheckBox.dxCheckBox("instance").option("disabled", true);

        const rowCount = $("#CorrectionGrid").dxDataGrid("instance").getVisibleRows().length;
        if (rowCount > 0) {
            enableButton("EditButton")
        }
        else disableButton("EditButton")
   }
   

    function getFormData(): any {
        const form = $("#CorrectionGridFilterForm").dxForm("instance");
        const data = form.option("formData");
        return data;
    }

    export function addTimeEntryCorrection() {

        const correctionGrid = $("#CorrectionGrid").dxDataGrid("instance");
        const selectedRows = correctionGrid.getSelectedRowsData();
        showNewEditDialog(selectedRows[0], false);


    }

    export function editTimeEntryCorrection() {

        const correctionGrid = $("#CorrectionGrid").dxDataGrid("instance");
        const selectedRows = correctionGrid.getSelectedRowsData();
        if (selectedRows[0] == null) {
            DevExpress.ui.notify("Please make a selection first!", "warning", 2000);
        } else {
            if (selectedRows[0].glEntryCreatedDateTime != null) {
                DevExpress.ui.notify("This record has been extracted and may not be edited", "warning", 2000);
            } else {
                showNewEditDialog(selectedRows[0], true);
            }
        }
    }

    function showNewEditDialog(data: any, isEdit: boolean) {

        employeeId = getEmployeeId(); //leave this in case employee selected in form, but no record selected for Add
        if (data != null) {
            employeeId = data.employeeId;
        }
        const params = { employeeId: employeeId, timeEntry: data, isEdit: isEdit };
        const timeEntryAnalysisAddEditDialog = new Areas.Dialogs.TimeEntryAnalysis.TimeEntryAnalysisAddEditDialog(newEditDialogClosing,
            params);
    }

    function newEditDialogClosing(dialogResult: DialogResult, data: any) {
        if (dialogResult === DialogResult.Cancel) {
            return;
        }

        const correctionGrid = $("#CorrectionGrid").dxDataGrid("instance");
        correctionGrid.deselectAll();

        Areas.refreshGrid("CorrectionGrid");
    
    }

}
